/**
 * Test IDs: the `data-testid` attributes the testing team's Playwright tests
 * find elements by. The rules and the full list are in `docs/test-ids.md`;
 * `src/test/testIdCatalogue.test.ts` fails when an ID here is missing there.
 */

/**
 * A value as one part of a test ID: lowercased, with each run of anything
 * other than a letter or a digit turned into one dash, and a camel-case name
 * split into its words. `SUPER_ADMIN` becomes `super-admin`, `lastLogin`
 * becomes `last-login`. An empty value - the "Any" or "Not set" option -
 * becomes `none`, so the ID never ends in a dash.
 */
export function testIdPart(value: string | number): string {
  const part = String(value)
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return part || 'none';
}

/**
 * `{ 'data-testid': id }`, for MUI slot props.
 *
 * MUI types its slot props without data attributes, so an object literal
 * holding one is refused by TypeScript. Typed as a plain object it spreads
 * into any of them: `slotProps={{ closeButton: testIdAttr('toast-close-button') }}`.
 */
export function testIdAttr(id: string): object {
  return { 'data-testid': id };
}
